import { Country, MetricGroup } from '../types'

export const getDataExistsPillar = (metricGroupsParam: MetricGroup[], countriesParam: Country[]) => {
  if (!metricGroupsParam || !countriesParam) return []
  return metricGroupsParam
    .map((metricGroup) => {
      const isPillarDataExists = metricGroup.metrics.some((metric) =>
        countriesParam.some((country) =>
          country.metadatas.some((metadata) => !!metadata[`${metric.shortname_scaled}_calc`]),
        ),
      )

      if (!isPillarDataExists) return undefined
      return metricGroup
    })
    .filter((metricGroup): metricGroup is MetricGroup => metricGroup !== undefined)
}

export const getDataKeyExistsPillar = (metricGroupsParam: MetricGroup[], countriesParam: Country[]) =>
  getDataExistsPillar(metricGroupsParam, countriesParam).map((metricGroup) => metricGroup.metricGroupNameDatakey)
